import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./Pages/Home";
import Index from "./Pages/Index";
import Login from "./Pages/Login/Login";
import { FrontEndRoutes } from "./config/front-end-routes";
import PageClientes from "./Pages/Clientes/PageClientes";
import PageProdutos from "./Pages/Produtos/PageProdutos";
import PagePedido from "./Pages/Pedidos/PagePedido";
import PagePedidos from "./Pages/Pedidos/PagePedidos";
import PageCliente from "./Pages/Clientes/PageCliente";
import PageProduto from "./Pages/Produtos/PageProduto";
import Layout from "./Layout/DefaultLayout";
import PageUsuarios from './Pages/Usuários/PageUsuarios';
import PageUsuario from './Pages/Usuários/PageUsuario';
import PageConfiguracoes from "./Pages/Configurações/PageSettings";
import PagePriceTables from "./Pages/Produtos/PriceProdutos/PageTabelaPrice";
import PageEditPriceTable from "./Pages/Produtos/PriceProdutos/TabelaPriceItem";
import PageDashboard from './Pages/Dashboard/PageDashboard';
import AppTitle from './Components/AppTitle';
import PageTitle from './Components/PageTitle';
import "@fortawesome/fontawesome-free/css/all.min.css";
import PageFrenteDeCaixa from './Pages/FrenteDeCaixa/PageFrenteDeCaixa';



const routesConfig = {
    [FrontEndRoutes.HOME]: {
        title: "Início",
        subtitle: "Bem-vindo ao painel",
        icon: "fa-solid fa-house",
    },
    [FrontEndRoutes.DASHBOARD]: {
        title: "Dashboard",
        subtitle: "Visão geral",
        icon: "fa-solid fa-gauge",
    },
    [FrontEndRoutes.CLIENTES.LIST]: {
        title: "Clientes",
        subtitle: "Listar",
        icon: "fa-solid fa-users",
    },
    [FrontEndRoutes.CLIENTES.CREATE]: {
        title: "Clientes",
        subtitle: "Cadastrar",
        icon: "fa-solid fa-user-plus",
    },
    [FrontEndRoutes.CLIENTES.EDIT]: {
        title: "Clientes",
        subtitle: "Editar",
        icon: "fa-solid fa-user-pen",
    },
    [FrontEndRoutes.USUARIOS.LIST]: {
        title: "Usuários",
        subtitle: "Listar",
        icon: "fa-solid fa-users",
    },
    [FrontEndRoutes.USUARIOS.CREATE]: {
        title: "Usuário",
        subtitle: "Cadastrar",
        icon: "fa-solid fa-user-plus",
    },
    [FrontEndRoutes.USUARIOS.EDIT]: {
        title: "Usuário",
        subtitle: "Editar",
        icon: "fa-solid fa-user-pen",
    },
    [FrontEndRoutes.PRODUTOS.LIST]: {
        title: "Produtos",
        subtitle: "Listar",
        icon: "fa-solid fa-box",
    },
    [FrontEndRoutes.PRODUTOS.CREATE]: {
        title: "Produto",
        subtitle: "Cadastrar",
        icon: "fa-solid fa-circle-plus",
    },
    [FrontEndRoutes.PRODUTOS.EDIT]: {
        title: "Produto",
        subtitle: "Editar",
        icon: "fa-solid fa-pen-to-square",
    },
    [FrontEndRoutes.TABELA.PRECO]: {
        title: "Tabela de Preços",
        subtitle: "Configuração de preços",
        icon: "fa-solid fa-tags",
    },
    [FrontEndRoutes.TABELA.EDIT]: {
        title: "Preço",
        subtitle: "Editar",
        icon: "fa-solid fa-dollar-sign",
    },
    [FrontEndRoutes.PEDIDOS.LIST]: {
        title: "Pedidos",
        subtitle: "Listar",
        icon: "fa-solid fa-cart-shopping",
    },
    [FrontEndRoutes.PEDIDOS.CREATE]: {
        title: "Pedido",
        subtitle: "Cadastrar",
        icon: "fa-solid fa-file-circle-plus",
    },
    [FrontEndRoutes.PEDIDOS.EDIT]: {
        title: "Pedido",
        subtitle: "Editar",
        icon: "fa-solid fa-pen-to-square",
    },
    [FrontEndRoutes.FRENTE_DE_CAIXA]: {
        title: "Frente De Caixa",
        subtitle: "Cadastrar",
        icon: "fa-solid fa-cash-register",
    },
    [FrontEndRoutes.CONFIG]: {
        title: "Configurações",
        subtitle: "",
        icon: "fa-solid fa-gear",
    },
};


const App: React.FC = () => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const location = useLocation();

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (token) {
            setIsAuthenticated(true);
        }
        setLoading(false);
    }, []);

    const PrivateRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
        if (!isAuthenticated && !loading) {
            return <Navigate to={FrontEndRoutes.LOGIN} state={{ from: location }} />;
        }
        return isAuthenticated ? children : null;
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <p>Carregando...</p>
            </div>
        );
    }

    // Rotas que não devem receber o layout
    const noLayoutRoutes = [FrontEndRoutes.LOGIN, FrontEndRoutes.INDEX];
    const isNoLayoutRoute = noLayoutRoutes.includes(location.pathname);

    return (
        <>
            <AppTitle /> {/* Mantém o título da aplicação */}
            {isNoLayoutRoute ? (
                <Routes>
                    <Route path={FrontEndRoutes.LOGIN} element={<Login />} />
                    <Route path={FrontEndRoutes.INDEX} element={<Login />} />
                </Routes>
            ) : (
                <>
                    <Layout>
                        <PageTitle routes={routesConfig} />
                        <Routes>
                            <Route path={FrontEndRoutes.HOME} element={<PrivateRoute><Home /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.DASHBOARD} element={<PrivateRoute><PageDashboard /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.CLIENTES.LIST} element={<PrivateRoute><PageClientes /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.CLIENTES.CREATE} element={<PrivateRoute><PageCliente /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.CLIENTES.EDIT} element={<PrivateRoute><PageCliente /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.USUARIOS.LIST} element={<PrivateRoute><PageUsuarios /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.USUARIOS.CREATE} element={<PrivateRoute><PageUsuario /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.USUARIOS.EDIT} element={<PrivateRoute><PageUsuario /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.PRODUTOS.LIST} element={<PrivateRoute><PageProdutos /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.PRODUTOS.CREATE} element={<PrivateRoute><PageProduto /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.PRODUTOS.EDIT} element={<PrivateRoute><PageProduto /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.TABELA.PRECO} element={<PrivateRoute><PagePriceTables /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.TABELA.EDIT} element={<PrivateRoute><PageEditPriceTable /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.PEDIDOS.LIST} element={<PrivateRoute><PagePedidos /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.PEDIDOS.CREATE} element={<PrivateRoute><PagePedido /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.PEDIDOS.EDIT} element={<PrivateRoute><PagePedido /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.FRENTE_DE_CAIXA} element={<PrivateRoute><PageFrenteDeCaixa /></PrivateRoute>} />
                            <Route path={FrontEndRoutes.CONFIG} element={<PrivateRoute><PageConfiguracoes /></PrivateRoute>} />
                        </Routes>
                    </Layout>
                </>
            )}
        </>
    );

};

export default App;
